// TrainingDashboardBlade/index.js
import React from 'react';
import { Paper, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import moment from 'moment';

import DashboardCountBox from '../../DashboardPanel/DashboardCountBox';
import RecordsListInCompanyBlade from '../RecordsListInCompanyBlade';
import { buttonNames } from '../../../constants';

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: 16,
    margin: 16
  },
  titleContainer: {
    position: 'relative',
    top: -16
  },
  bladeIcon: {
    position: 'absolute'
  },
  bladeTitle: {
    marginTop: -4,
    position: 'absolute',
    left: 32,
    top: 6
  },
  countBoxContainer: {
    display: 'flex',
    marginTop: 24
  },
  countBox: {
    width: '100%'
  },
  seeMoreButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 8
  },
  seeMoreButton: {
    background: '#54a000',
    color: 'white',
    width: 150,
    height: 36,
    '&:hover': {
      background: 'white',
      color: '#54a000',
      border: '1px solid #54a000'
    }
  },
  noRecords: {
    fontSize: 20,
    textAlign: 'center',
    color: '#424242',
    marginBottom: 0
  }
}));

function TrainingDashboardCompanyBlade(props) {
  const classes = useStyles();

  const {
    companyId,
    fetchAllCourseRecordssForCompany,
    fetchAllCoursesForCompany,
    allCourses,
    setCurrentBranchesRecord,
    handleCourseRecordEditClick,
    courseRecords
  } = props;

  let courses = courseRecords;

  React.useEffect(
    () => {
      if (companyId) {
        fetchAllCourseRecordssForCompany(companyId);
        fetchAllCoursesForCompany(companyId);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [companyId]
  );

  if (courses.length > 0) {
    //removing courses with no data
    courses = courses.filter(
      (course) => course.overdueCount > 0 || course.upcomingCount > 0
    );
  }

  let initialValue = 0;
  const upcomingCourses = courses.reduce(
    (acc, curr) => acc + curr.upcomingCount,
    initialValue
  );
  initialValue = 0;
  const overDueCourses = courses.reduce(
    (acc, curr) => acc + curr.overdueCount,
    initialValue
  );

  const handleAddEditClick = (item) => {
    setCurrentBranchesRecord(buttonNames.COURSES);
    handleCourseRecordEditClick(item);
  };

  const handleSeeMoreButtonForCoursesClick = (recordType) => {
    setCurrentBranchesRecord(recordType);
  };

  return (
    <React.Fragment>
      <Paper className={classes.paper}>
        <h3 className={classes.titleContainer}>
          <MenuBookIcon className={classes.bladeIcon} />
          <span className={classes.bladeTitle}>Training</span>
        </h3>

        <div className={classes.countBoxContainer}>
          <div className={classes.countBox}>
            <DashboardCountBox count={upcomingCourses} label="upcoming" />
          </div>
          <div className={classes.countBox}>
            <DashboardCountBox
              count={overDueCourses}
              label="overdue"
              isDanger={overDueCourses > 0}
            />
          </div>
        </div>

        <RecordsListInCompanyBlade
          allCourses={allCourses}
          items={courses}
          source="training"
          titleField="personnelName"
          subTitleField="courseName"
          dateLabel="Expire"
          dateField="nextCourseDate"
          courseId="courseId"
          branchIdField="branchId"
          branchNameField="branchName"
          handleAddEditClick={handleAddEditClick}
        />

        {courses.length === 0 ? (
          <p className={classes.noRecords}>No records</p>
        ) : null}

        {/* {courses.length > 5 ? (
          <div className={classes.seeMoreButtonContainer}>
            <Button
              color="secondary"
              className={classes.seeMoreButton}
              onClick={() =>
                handleSeeMoreButtonForCoursesClick(buttonNames.COURSES)
              }
            >
              See More
            </Button>
          </div>
        ) : null} */}
      </Paper>
    </React.Fragment>
  );
}

export default TrainingDashboardCompanyBlade;
